export const ENTRY = "/";
export const ENTRY_REDIRECT = "/redirect";
export const SIGNUP = "/signup";
export const SIGNUP_SSO = "/signup/sso";
export const SIGNUP_VERIFY = "/signup/verify";
export const SIGNIN = "/signin";
export const OAUTH_CALLBACK = "/auth/callback/:provider";
export const SIGNIN_2FA = "/signin/2fa";
export const PASSWORD_RESET = "/password/reset";
export const HOME = "/";
export const CAREER = "/careers";
export const CAREER_DETAIL = "/careers/:id";
export const ABOUT_US = "/about-us";
export const CONTACT_US = "/contact-us";
export const HOME_CATEGORY_DETAIL = "/categories/:id";
export const HOME_CATEGORY_FREELANCER = "/categories/:id/freelancers";
export const HOME_CATEGORY_FREELANCER_DETAILS =
  "/categories/:id/freelancers/:accountId/details";
export const HOME_FREELANCER_DETAILS =
  "/freelancers/:accountId/details";
export const ONBOARDING = "/onboarding";
export const ONBOARDING_MANUAL = "/onboarding/manual";
export const ONBOARDING_LINKEDIN = "/onboarding/linkedin";
export const ONBOARDING_RESUME = "/onboarding/resume";
export const DASHBOARD = "/dashboard";
export const PROFILE = "/profile";
export const PROFILE_UPDATE = "/profile/update";
export const PROFILE_CONTACT = "profile/:id/contact";
export const PORTFOLIO = "/portfolios";
export const PORTFOLIO_DETAILS = "/portfolios/my-portfolio";
export const PORTFOLIO_CREATE = "/portfolios/create";
export const PORTFOLIO_PROJECT_CREATE = "/portfolios/:id/project/create";
export const PORTFOLIO_PROJECT_EDIT = "/portfolios/:id/project/:projectId/edit";
export const PORTFOLIO_PROJECT_DETAILS = "/portfolios/:id/project/:projectId";
export const JOB = "/jobs";
export const JOB_CREATE = "/jobs/create";
export const JOB_EDIT = "/jobs/:id/edit";
export const JOB_DETAIL = "/jobs/:id";
export const JOB_APPLY = "/jobs/:id/apply";
export const JOB_REVIEW = "/jobs/:id/review";
export const JOB_REVIEW_TAB = "/jobs/:id/review/:tab";
export const JOB_HIRE = "/jobs/:id/hire";
export const INVITATION = "/invitations";
export const INVITATION_DETAIL = "/invitations/:id";
export const PROPOSAL = "/proposals";
export const PROPOSAL_DETAIL = "/proposals/:id";
export const PROPOSAL_SUBMIT = "/proposals/submit";
export const PROPOSAL_EDIT = "/proposals/:id/edit";
export const CONTRACT = "/contracts";
export const CONTRACT_DETAILS_TAB = "/contracts/:id/:tab";
export const CONTRACTS_DETAILS = "/contracts/:id";
export const CONTRACT_SEND = "/contracts/send";
export const CONTRACT_ACTIVE = "/contracts/active";
export const CONTRACT_ACTIVE_TAB = "/contracts/active/:tab";
export const CONTRACT_EDIT = "/contracts/:id/edit";
export const PROJECT = "/projects";
export const PROJECT_CREATE = "/projects/create";
export const PROJECT_EDIT = "/projects/:id/edit";
export const PROJECT_SEARCH = "/projects/search";
export const PROJECT_DETAIL = "/projects/:id";
export const PROJECT_DETAIL_REQUIREMENT = "/projects/:id/requirement";
export const MESSAGE = "/messages";
export const MESSAGE_ROOM = "/messages/:id";
export const SETTING = "/settings";
export const NOTIFICATION = "/notifications";
export const NOTIFICATION_DETAIL = "/notifications/:id";
export const TEAM = "/team";
export const TEAM_MEMBERS = "/team/:teamId/members";
export const ACCOUNT_MEMBER = "/account-members";
export const ACCESS_CONTROL = "/access-control";
export const ACCESS_CONTROL_ROLE_CREATE = "/access-control/roles/create";
export const ACCESS_CONTROL_ROLE_EDIT = "/access-control/roles/:id/edit";
export const ACCESS_CONTROL_RESOURCE_SET_CREATE =
  "/access-control/resource-sets/create";
export const ACCESS_CONTROL_RESOURCE_SET_EDIT =
  "/access-control/resource-sets/:id/edit";
export const TALENT = "/talents";
export const TALENT_DETAIL = "/talents/:id";
export const PAYMENT = "/payments";
export const PAYMENT_TRANSACTION_HISTORY_DETAILS =
  "/payments/transaction-history/:id";
export const PAYMENT_CHECKOUT = "/payments/checkout/:access_code";
export const PAYMENT_CHECKOUT_RETURN =
  "/payments/checkout/:access_code/:action";
export const TRANSACTION = "/transactions";
export const TRANSACTION_TAB = "/transactions/:tab";
export const TRANSACTION_DETAILS = "/transactions/:tab/:id";
export const PRIVACY_POLICY = "/privacy-policy";
export const TERM_AND_CONDITION = "/terms-and-conditions";
